import _objectSpread from "@babel/runtime/helpers/objectSpread2";

/*
 * Copy of https://github.com/NerdWallet/nw-client-lib/blob/master/src/tracking/components/impression-click.jsx
 *
 */

/**
 *
 * This is a `smart` component. It will pass along an impression info for an
 * impression of the same ID, if it has been fired
 *
 */
import { connect } from 'react-redux';
import { wrapWithClickProps } from './apply-now-click';

var wrapWithImpressionClickProps = function wrapWithImpressionClickProps(component) {
  return connect(function (state, ownProps) {
    if (state.impressions && state.impressions[ownProps.id]) {
      var impression = state.impressions[ownProps.id];

      var props = _objectSpread({}, ownProps);

      props.eventProps = _objectSpread({
        clickHeader: impression.impressionHeader
      }, props.eventProps);
      return props;
    }

    return ownProps;
  })(wrapWithClickProps(component));
};

export default wrapWithImpressionClickProps('a');
export { wrapWithImpressionClickProps };